import { Injectable } from '@angular/core';
import { AbcCore, CompareHelper, ObjectHelper } from '@barthauer/abc/core';
import { ICoreDataEntity } from '@barthauer/abc/core/data';
import { GridAdapter, _AbcGridColumn, _AbcGridComponent } from '@barthauer/abc/ui-components';
import { AbcGridContextMenuManager } from 'libs/abc/ui-components/src/lib/core/src/abc-grid/abc-grid-context-menu-manager';
import { LayoutColumnViewModel } from '../viewModels/layout.viewModel';

@Injectable({
  providedIn: 'root',
})
export class HignaService {
  public readonly IdColumnName: string = ObjectHelper.nameof<ICoreDataEntity>('Id');
  public readonly ObjectTypeColumnName: string = ObjectHelper.nameof<ICoreDataEntity>('ObjectType');
  constructor(private core: AbcCore) {}

  public getLayoutTransferedGridColumns(columns: LayoutColumnViewModel[]): _AbcGridColumn[] {
    const gridColumns: _AbcGridColumn[] = new Array<_AbcGridColumn>();
    if (columns) {
      for (const c of columns) {
        gridColumns.push(this.transferFromViewModelToGridColumn(c));
      }
      gridColumns.push({
        caption: this.IdColumnName,
        dataField: this.IdColumnName,
        name: this.IdColumnName,
        visible: false,
        showInColumnChooser: false,
        allowFiltering: true,
      });
    }
    return gridColumns;
  }

  private transferFromViewModelToGridColumn(column: LayoutColumnViewModel): _AbcGridColumn {
    let gridColumn: _AbcGridColumn = new _AbcGridColumn();
    try {
      gridColumn.caption = column?.gridCaption || this.insertSpaces(column.oPath);
      gridColumn.dataField = column?.dataField;
      gridColumn.dataType = column?.dataType;
      gridColumn.format = _AbcGridComponent.getColumnFormat(column?.dataType, column.editMask ?? column.format);
      gridColumn.name = column?.dataField;
      gridColumn.showInColumnChooser = column?.showInColumnChooser;
      gridColumn.visible = column?.visible;
      gridColumn.visibleIndex = column?.visibleIndex;
      gridColumn.sortOrder = column?.sortOrder;
      gridColumn.sortIndex = column?.sortIndex;
      gridColumn.allowGrouping = true;
      if (column?.isUserDefined) {
        gridColumn[AbcGridContextMenuManager.CustomOPathColumnKey] = column?.oPath;
      }
      if (column?.oPath?.endsWith('__Json')) {
        gridColumn.customizeText = (e) => {
          if (ObjectHelper.isObjectOrArray(e.value)) {
            return JSON.stringify(e.value);
          }
        };
      }
      GridAdapter.prepareGridColumn(gridColumn);
      return gridColumn;
    } catch (err) {
      this.core.error.publish(err);
    }
  }

  private insertSpaces(pascalCaseString: string): string {
    pascalCaseString = pascalCaseString?.replace(/([a-z])([A-Z])/g, '$1 $2');
    return pascalCaseString;
  }
}
